export default [
  {
    question: "How often do you use the mask?",
    answer1: "Always",
    answer2: "Almost always",
    answer3: "Frequently",
    answer4: "Sometimes",
    answer5: "Almost never",
    answer6: "Never",
    img: "/images/survey/mascarilla.svg",
    advice: "You should wear the mask more frequently.",
    inverted: true,
  },
  {
    question: "How often do you wash your hands?",
    answer1: "Always",
    answer2: "Almost always",
    answer3: "Frequently",
    answer4: "Sometimes",
    answer5: "Almost never",
    answer6: "Never",
    img: "/images/survey/lavado-manos.svg",
    advice: "You should wash your hands more frequently.",
    inverted: true,
  },
  {
    question: "How many hours per week do you stay out of home in open spaces?",
    answer1: "More than 50",
    answer2: "40 to 50",
    answer3: "30 to 40",
    answer4: "20 to 30",
    answer5: "10 to 20",
    answer6: "0 to 10",
    img: "/images/survey/espacios-abiertos.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "How many hours per week do you stay out of home within closed spaces?",
    answer1: "More than 50",
    answer2: "40 to 50",
    answer3: "30 to 40",
    answer4: "20 to 30",
    answer5: "10 to 20",
    answer6: "0 to 10",
    img: "/images/survey/espacios-cerrados.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "How often do you touch your face?",
    answer1: "Always",
    answer2: "Almost always",
    answer3: "Frequently",
    answer4: "Sometimes",
    answer5: "Almost never",
    answer6: "Never",
    img: "/images/survey/tocar-cara.svg",
    advice: "Try to be aware and not touch your face.",
    inverted: false,
  },
  {
    question: "How many people live in your house, apart from you?",
    answer1: "5 or more",
    answer2: "4",
    answer3: "3",
    answer4: "2",
    answer5: "1",
    answer6: "0",
    img: "/images/survey/habitantes-casa.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Do you keep the recommended social distance with the rest of people?",
    answer1: "Always",
    answer2: "Almost always",
    answer3: "Frequently",
    answer4: "Sometimes",
    answer5: "Almost never",
    answer6: "Never",
    img: "/images/survey/distanciamiento.svg",
    advice: "Try to keep the recommended distance from other people.",
    inverted: true,
  },
  {
    question: "Do you use cash?",
    answer1: "Always",
    answer2: "Almost always",
    answer3: "Frequently",
    answer4: "Sometimes",
    answer5: "Almost never",
    answer6: "Never",
    img: "/images/survey/dinero.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "How many minutes per week do you use the community elevator?",
    answer1: "Never",
    answer2: "0 to 2",
    answer3: "2 to 5",
    answer4: "5 to 10",
    answer5: "10 to 20",
    answer6: "More than 20",
    img: "/images/survey/ascensor.svg",
    advice:
      "If possible use the stairs, which also gives you a little exercise.",
    inverted: true,
  },
  {
    question: "How many hours per week do you use the public transport?",
    answer1: "More than 25",
    answer2: "20 to 25",
    answer3: "15 to 20",
    answer4: "10 to 15",
    answer5: "5 to 10",
    answer6: "0 to 5",
    img: "/images/survey/transporte-publico.svg",
    advice: "",
    inverted: false,
  },
];
